export var HealthScoreColor;
(function (HealthScoreColor) {
    HealthScoreColor["green"] = "green";
    HealthScoreColor["yellow"] = "yellow";
    HealthScoreColor["red"] = "red";
})(HealthScoreColor || (HealthScoreColor = {}));
